import { IS_STAGING_ENV, IS_DEV_ENV, IS_ALPHA_ENV } from '../constants/config';

export const WEDDING_VENUES = '/wedding-venues/';
export type WEDDING_VENUES = typeof WEDDING_VENUES;

export const VENDOR_SIGNUP = '/vendor-signup/';
export type VENDOR_SIGNUP = typeof VENDOR_SIGNUP;

export const VENUE_PROFILE = '/venue/:id(\\d+)/';
export type VENUE_PROFILE = typeof VENUE_PROFILE;

export const VENUE_PROFILE_NAME = '/venue/:id(\\d+)/:name([^/]+)/';
export type VENUE_PROFILE_NAME = typeof VENUE_PROFILE_NAME;

export const VENUE_PROFILE_QUOTE = '/venue/:id(\\d+)/([^/]+/)?:action(contact|request-quote)/';
export type VENUE_PROFILE_QUOTE = typeof VENUE_PROFILE_QUOTE;

export const ALL_VENUE_PROFILE_URLS = [VENUE_PROFILE, VENUE_PROFILE_NAME, VENUE_PROFILE_QUOTE];

export const SRP_PAGE = '/wedding-venues/';
export type SRP_PAGE = typeof SRP_PAGE;

export const NOT_FOUND = '/404/';
export type NOT_FOUND = typeof NOT_FOUND;

export const CURATED_LIST = '/guides/:bucket-wedding-venues/:market?/:region?/';
export type CURATED_LIST = typeof CURATED_LIST;

export const STYLED_CURATED_LIST = '/guides/:style([\\w\\-]+)-wedding-venues/';
export type STYLED_CURATED_LIST = typeof STYLED_CURATED_LIST;

export const VENUE_MANAGEMENT = '/twsadmin/apps/venue-management/:item(general|availability|amenities)/';
export type VENUE_MANAGEMENT = typeof VENUE_MANAGEMENT;

export const DESTINATION_WEDDINGS_LANDING = '/guides/:guide(destination-weddings-[\\w\\-]+)/';
export type DESTINATION_WEDDINGS_LANDING = typeof DESTINATION_WEDDINGS_LANDING;

export const ALL_STYLES_LANDING_PAGE = '/wedding-venue-styles/';
export type ALL_STYLES_LANDING_PAGE = typeof ALL_STYLES_LANDING_PAGE;

export const MASS_INQUIRY_PAGE = '/send-mass-inquiry/';
export type MASS_INQUIRY_PAGE = typeof MASS_INQUIRY_PAGE;

export const RFP_EMAIL = '/rfp-email/'; // TODO probably need to change this address
export type RFP_EMAIL = typeof RFP_EMAIL;

export const TYPEAHEAD_CDN_URL =
    IS_STAGING_ENV || IS_DEV_ENV
        ? 'https://cdn-sg50.wedding-spot.com/typeahead/typeahead_1.json'
        : IS_ALPHA_ENV
        ? 'https://cdn-ap50.wedding-spot.com/typeahead/typeahead_1.json'
        : 'https://cdn.wedding-spot.com/typeahead/typeahead_1.json';
export type TYPEAHEAD_CDN_URL = typeof TYPEAHEAD_CDN_URL;

export const CCPA_DO_NOT_SELL_URL = '/ccpa/do-not-sell/';
export type CCPA_DO_NOT_SELL_URL = typeof CCPA_DO_NOT_SELL_URL;

export const CHECKOUT = '/checkout/';
export type CHECKOUT = typeof CHECKOUT;

export const getLoacationFullURL = (slug: string) => WEDDING_VENUES + slug;

export const getVenueURL = (venueId: number | string, slug?: string) => '/venue/' + venueId + '/' + (slug ? slug + '/' : '');

export const getStyleURL = (slug: string) => WEDDING_VENUES + slug + '/';

export const getStyleSrpUrl = (slug: string) => `/${slug}-wedding-venues/`;

export const getMarketAndRegionURL = (market: string, region?: string) =>
    SRP_PAGE + market.replace(' ', '-') + '/' + (region ? region.replace(' ', '-') + '/' : '');

export const getContactVenueURL = (venueId: string | number) => `/venue/${venueId}/contact/`;
export const getQuoteRequestURL = (venueId: string | number) => `/venue/${venueId}/request-quote/`;

export * from './srp-urls';
